import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { downCarrot } from '../library/Svgs';
import PerformanceReportsFilter from './PerformanceReportsFilter';
import moment from 'moment';
import $ from 'jquery';
import { triangleHead } from '../library/Svgs';

const PerformanceReportsListItem = (props) => {
  const {
    url, image, title, searchItems,
  } = props;
  return (
    <li key={url}>
      <Link to={url}>
        <div
          className="org-image"
          style={{
            background: `url(${image})`,
            backgroundRepeat: 'no-repeat',
            backgroundColor: 'white',
            backgroundPosition: 'center',
            backgroundSize: 'contain',
          }}
          alt={title}
        >
          <div className="padding" />
        </div>
        <span href={url} className="org-title">
          {title}
        </span>
        <span className="right-arrow">
          <span className="line" />
          <span className="circle-head" dangerouslySetInnerHTML={{ __html: triangleHead }} />
        </span>
      </Link>
    </li>
  );
};

class PerformanceReportsArchive extends Component {
  constructor(props) {
    super(props);

    // Set Up Reports Search Strings
    let autoCompleteValues = [];
    const reports = props.reports.map((report) => {
      Object.keys(report.reports).forEach((key) => {
        const currentAutoCompleteValues = [report.reports[key].title];
        // currentAutoCompleteValues.push(report.title);
        // currentAutoCompleteValues.push(moment(report.start_date).format('MMMM'));
        // currentAutoCompleteValues.push(moment(report.end_date).format('MMMM'));
        autoCompleteValues = autoCompleteValues.concat(currentAutoCompleteValues);
        report.reports[key].searchString = currentAutoCompleteValues.join(' ');
      });
      return report;
    });

    autoCompleteValues = autoCompleteValues
      .filter((x, i, a) => a.indexOf(x) == i)
      .map(x => ({ label: x }))
      .sort((a, b) => {
        const textA = a.label.toUpperCase();
        const textB = b.label.toUpperCase();
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });

    this.state = {
      view: 'grid',
      currentlyViewing: props.reports[0].slug,
      currentSearchTerm: '',
      year: 'year',
      reports,
      autoCompleteValues,
      page: 1,
      orgNames: props.reports
        .reduce((a, x) => a.concat(Object.keys(x.reports).map(y => x.reports[y].title)), [])
        .filter((x, i, a) => a.indexOf(x) == i)
        .map(x => ({ label: x })),
      reportNames: props.reports.map(x => ({ label: x.title })),
      years: props.reports
        .map(x => moment(x.start_date).format('YYYY'))
        .filter((x, i, a) => a.indexOf(x) == i)
        .sort(),
    };
    this.setView = this.setView.bind(this);
    this.setCurrentlyViewing = this.setCurrentlyViewing.bind(this);
    this.setCurrentSearchTerm = this.setCurrentSearchTerm.bind(this);
    this.setYear = this.setYear.bind(this);
    this.scrollToOpen = this.scrollToOpen.bind(this);
  }

  setView(view) {
    this.setState({ view });
  }

  scrollToOpen() {
    const headerHeight = document.querySelector('header').offsetHeight;
    setTimeout(() => {
      $('html, body').animate({
        scrollTop:
          document.querySelector('.single-performance-report.open').offsetTop - headerHeight,
      });
    }, 100);
  }

  setCurrentlyViewing(slug) {
    const { currentlyViewing } = this.state;
    if (currentlyViewing !== slug) {
      this.setState({ currentlyViewing: slug }, this.scrollToOpen);
    } else {
      this.setState({ currentlyViewing: '' });
    }
  }

  setCurrentSearchTerm(term) {
    this.setState({ currentSearchTerm: term, page: 1 });
  }

  setYear(y) {
    this.setState({ year: y, page: 1 });
  }

  render() {
    const { reports } = this.state;
    const {
      view,
      currentlyViewing,
      currentSearchTerm,
      orgNames,
      reportNames,
      years,
      year,
      autoCompleteValues,
      page,
    } = this.state;

    const filteredReports = reports
      .sort((a, b) => b.end_date - a.end_date)
      .filter(report => year === 'year' || year === report.end_date.slice(0, 4))
      .map((x, i) => {
        x.reportKeys = Object.keys(x.reports).filter(report =>
          (currentSearchTerm === '' && year === 'year') ||
            (currentSearchTerm === '' ||
              (currentSearchTerm !== '' &&
                x.reports[report].searchString
                  .toLowerCase()
                  .indexOf(currentSearchTerm.toLowerCase()) >= 0)),

          //     &&
          // (year === 'year' ||
          //   (year !== 'year' &&
          //     x.reports[report].searchString.toLowerCase().indexOf(year) >= 0))
        );
        return x;
      })
      .filter(report => report.reportKeys.length > 0);

    const activeReports = filteredReports.slice(0, page * 4);

    return (
      <div className="filter-reports-archive">
        <PerformanceReportsFilter
          setView={this.setView}
          view={view}
          currentSearchTerm={currentSearchTerm}
          setCurrentSearchTerm={this.setCurrentSearchTerm}
          autoCompleteValues={autoCompleteValues}
          years={years}
          year={year}
          setYear={this.setYear}
        />
        <div className={`performance-report-list org-list ${view}`}>
          {activeReports.map((x, i) => {
            const allOpen = !(currentSearchTerm === '' && year === 'year');

            return (
              <div
                className={`single-performance-report${
                  x.slug === currentlyViewing || allOpen ? ' open' : ''
                }`}
                key={x.slug}
                style={{ display: allOpen && x.reportKeys.length == 0 ? 'none' : 'block' }}
              >
                <div className="container">
                  <button
                    className="title-bar"
                    onClick={() => {
                      this.setCurrentlyViewing(x.slug);
                    }}
                  >
                    <h3> {x.title}</h3>
                    <span
                      className="icon"
                      dangerouslySetInnerHTML={{
                        __html: downCarrot(i === 0 ? '#FFFFFF' : '#783c96'),
                      }}
                    />
                  </button>
                  <div className="content">
                    <ul>
                      {x.reportKeys.map((key) => {
                        const y = x.reports[key].children[0];
                        return (
                          <PerformanceReportsListItem
                            {...x.reports[key]}
                            url={`/${x.slug}/${x.reports[key].slug}/${y.slug}`}
                            currentlyViewing={this.state.currentlyViewing}
                            setCurrentlyViewing={this.setCurrentlyViewing}
                            key={`perf-list-${key}`}
                          />
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {filteredReports.length > page * 4 ? (
          <div className="load-more-container">
            <a
              className="load-more"
              onClick={(e) => {
                this.setState({ page: page + 1 });
              }}
              href="javascript:void(0);"
            >
              Load More
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
}

PerformanceReportsArchive.propTypes = {
  reports: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export default PerformanceReportsArchive;
